import $ from 'jquery';
import Mustache from 'mustache';
import { tooltip as ToolTip } from 'plugin.tooltip';
import cookieUtils from 'cookie-utils';
import headerAnalytics from 'header.analytics';
import hfConfig from 'hfConfig';
import thdCustomer from 'thd-customer';
import utils from '../shared/utils';

const maml = {};
const privateMethods = {};
const nonSecureHostName = hfConfig.nonSecureHostName;
let headerMyAccountTooltip;
// determine if the cart is replete with items
privateMethods.updateAccountIcon = function _updateAccountIcon(isLoggedIn, isPersisted) {
  const userSignedIn = isLoggedIn || isPersisted;
  const accountIcon = document.querySelector('.MyAccount__icon');

  accountIcon?.querySelector('.HeaderIcon__primary')?.classList.toggle('HeaderIcon__primary--active', userSignedIn);

  accountIcon?.querySelector('.HeaderIcon__secondary')?.classList.toggle('HeaderIcon__secondary--active', userSignedIn);
};

privateMethods.reloadPage = function _reloadPage() {
  window.location.reload();
}

privateMethods.isPIPOrCollectionPage = function _isPIPOrCollectionPage() {
  const isPIP = (window.location.href.indexOf('/p/') !== -1);
  const isCollections = (window.location.href.indexOf('/collection/') !== -1);
  return (isPIP || isCollections);
};
privateMethods.clearPerksSessionStorage = function clearPerksSessionStorage() {
  return thdCustomer.clearPerksSession;
};
privateMethods.triggerSignInBubble = function _triggerSignInBubble() {
  const triggerSignInElement = document.getElementById('triggerSignIn');
  if (triggerSignInElement) {
    new ToolTip(triggerSignInElement, {
      type: 'click',
      noPad: true,
      closeOnClick: true,
      content: ' ',
      width: 'small',
      onOpen: function _onOpenTooltip(tooltip, complete) {
        const headerSignInBubbleElement = document.getElementById('Header_signInBubble');
        headerSignInBubbleElement?.classList.remove('hide');
        tooltip.appendChild(headerSignInBubbleElement);
        complete();
        cookieUtils.fed_CreateCookie('signInBubble', true, null);
      }
    });
    triggerSignInElement.click();
    setTimeout(function () {
      if (!document.getElementById('Header_signInBubble')?.closest('[id*="tooltip"]').classList.contains('ToolTip--closed')) {
        triggerSignInElement.click();
      }
    }, 7000);
  }
};

privateMethods.initialize = function initialize(useJsonP) {
  const template = {
    loggedIn: '<div class="MyAccount__userInfo SimpleFlyout__link--bold">Hello, <span class="MyAccount__userInfo__name">{{usersName}}</span></div>',
    loggedInLite: '<span class="MyAccount__userInfo SimpleFlyout__link--bold">My Account</span>',
    loggedOut: '<div class="MyAccount__label SimpleFlyout__link--bold">My Account</div>'
  };

  /***
     * NPM module, thd-customer, reads THD_USER, THD_USER_SESSION, THD_CUSTOMER cookie from document.cookie
     * However, these cookies have secure flag which allows them to be only accessible in HTTPs
     */
  const { isLoggedIn, isPersisted } = thdCustomer;

  // only grab usersName when it's in logged in or persisted log in state
  privateMethods.usersName = (isLoggedIn || isPersisted) ? cookieUtils.getTHDUserName() : '';

  privateMethods.updateAccountIcon(isLoggedIn, isPersisted);

  privateMethods.determineAuthState(template);

  // Buy It Again only for logged in or persisted user;

  if (!cookieUtils.hasBrowserCookie('signInBubble') && !Boolean(privateMethods.usersName) && hfConfig.enableSignInBubble === true && hfConfig.currentChannel !== 'mobile') {
    if (privateMethods.isPIPOrCollectionPage()) {
      // Added timeout for PIP/Collection pages as they get reloaded when accessed directly
      setTimeout(function () {
        privateMethods.triggerSignInBubble();
      }, 3000);
    } else {
      privateMethods.triggerSignInBubble();
    }
  }
  
  const myHeaderAccountElement = document.getElementById('headerMyAccount');
  document.getElementById('b2x-links')?.remove();
  if (myHeaderAccountElement) {
    headerMyAccountTooltip = new ToolTip(myHeaderAccountElement, {
      type: 'click',
      noPad: true,
      content: ' ',
      closeOnClick: true,
      onOpen: function _onOpenTooltip(tooltip, complete) {
        document.querySelector('#B2XLinks')?.remove();
        const headerMyAccountDropdownElement = document.getElementById('headerMyAccountDropdown');
        headerMyAccountDropdownElement?.classList.remove('u--hide');
        tooltip.appendChild(headerMyAccountDropdownElement);
        complete();
        // TODO need to update this vanilla once tooltips is updated
        // document.dispatchEvent(new CustomEvent('openingHeaderToolTip',
        //   { detail: 'myaccount' }));
        $(document).trigger('openingHeaderToolTip', 'myaccount');
      }
    });
  }

  // attach event listener for tooltip close
  document.addEventListener('closeHeaderMyAccountTooltip', () => {
    if (headerMyAccountTooltip) {
      headerMyAccountTooltip.close();
    }
  })

  // attach event listener to signOut link
  document.querySelector('button#signOut')?.addEventListener('click', privateMethods.signOut);
  document.querySelector('button#ma-signout')?.addEventListener('click', privateMethods.signOut);

  /**
     * for DEMO Page
     */
  utils.delegateListeners(['click'], '.index-web__signin', () => {
    document.cookie = 'THD_USER="eyJjdXN0b21lclR5cGUiOiJCMkMiLCJzdm9jQ3VzdG9tZXJBY2NvdW50SWQiOiIwM0VEMjU2REZCMDAzNEEwMFMiLCJsb2dvbklkIjoidmVua2F0ZXNoLmNoaXRuaXNAZ21haWwuY29tIiwidXNlcklkIjoiMDUxM0UxNTJFMkRFMDMxRDBVIn0="; path=/;';
    document.cookie = 'THD_USER_SESSION=KPO6uUrjPLK8EdMUP9zsjXlEWWk.*AAJTSQACMDIAAlNLABw4WXQ3UEVZanpyZUkyN25HWGpoZnREbWNldTA9AAJTMQACMDE.*; path=/;';
    privateMethods.reloadPage();
  });

  utils.delegateListeners(['click'], '.index-web__signout', () => {
    document.cookie = 'THD_USER=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'THD_USER_SESSION=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    privateMethods.reloadPage();
  });

  return privateMethods;
};

privateMethods.determineAuthState = function determineAuthState(template) {
  let html;
  const { isLoggedIn, isPersisted } = thdCustomer;
  const { usersName } = privateMethods;
  const spsoSignInElement = document.getElementById('SPSOSignIn');
  const spsoRegisterElement = document.getElementById('SPSORegister');
  const authDividerElement = document.getElementById('authDivider');
  const authSignOutElement = document.getElementById('authSignOut');
  const myAccountMessageElement = document.querySelector('.MyAccount__message');

  if (!isLoggedIn && !isPersisted) { // when there is no logged in user information
    // update dropdown links only in guest flow
    privateMethods.updateDropdownLinks();

    html = Mustache.render(template.loggedOut, privateMethods);
    utils.setInnerHtml('.headerMyAccountTitle', html);

    if (spsoSignInElement?.classList.contains('u--hide') ||
      spsoRegisterElement?.classList.contains('u--hide') ||
      authDividerElement?.classList.contains('u--hide'))
    {
      spsoSignInElement?.classList.remove('u--hide');
      spsoRegisterElement?.classList.remove('u--hide');
      authDividerElement?.classList.remove('u--hide');
    }

    if (!(authSignOutElement?.classList.contains('u--hide') ||
      myAccountMessageElement?.classList.contains('u--hide')))
    {
      authSignOutElement?.classList.add('u--hide');
      myAccountMessageElement?.classList.add('u--hide');
    }

    document.querySelector('#signOut.SimpleFlyout__link')?.parentNode.classList.add('u--hide');
    document.querySelector('#simpleFlyout .MyAccount__label--loggedout')?.classList.toggle('u--hide', !Boolean(privateMethods.usersName));
    // update dropdown links only in guest flow
    return;
  }

  if (isPersisted || isLoggedIn) {
    // update the name in the button
    html = Mustache.render(template.loggedInLite, privateMethods);
      
    document.getElementById('ma-drawer__auth-buttons')?.classList.add('u--hide');
    document.getElementById('ma-signout')?.closest('.ma-drawer__link')?.classList.remove('u--hide');
    document.getElementById('ma-signout-b2x')?.closest('.ma-drawer__link')?.classList.remove('u--hide');
    const maDrawerGreetingElement = document.getElementById('ma-drawer__greeting');
    if (usersName && usersName !== 'self') {
      html = Mustache.render(template.loggedIn, privateMethods);
      if (maDrawerGreetingElement) {
        maDrawerGreetingElement.textContent = `Welcome Back, ${privateMethods.usersName}!`;
      }
    } else {
      if (maDrawerGreetingElement) {
        document.getElementById('ma-drawer__greeting').textContent = 'Welcome Back!';
      }
    }
  }

  if (usersName === 'self') {
    html = Mustache.render(template.loggedInLite, privateMethods);
  }

  if (isLoggedIn && hfConfig.currentChannel === 'mobile') {
    document.querySelector('.SimpleFlyout__myAccount')?.setAttribute('href', `//${nonSecureHostName}/account/view/mobile/menu`);
  }

  utils.setInnerHtml('.headerMyAccountTitle', html);

  // TODO: Create a Util method to handle this like gentlemen with a bit more class and style.
  if (!spsoSignInElement?.classList.contains('u--hide')) {
    spsoSignInElement?.classList.add('u--hide');
  }
  if (!spsoRegisterElement?.classList.contains('u--hide')) {
    spsoRegisterElement?.classList.add('u--hide');
  }
  if (!authDividerElement?.classList.contains('u--hide')) {
    authDividerElement?.classList.add('u--hide');
  }

  if (authSignOutElement?.classList.contains('u--hide') || myAccountMessageElement?.classList.contains('u--hide')) {
    authSignOutElement?.classList.remove('u--hide');
    myAccountMessageElement?.classList.remove('u--hide');
  }

  document.querySelector('#simpleFlyout .MyAccount__label--loggedout')?.classList
    .toggle('u--hide', !Boolean(privateMethods.usersName));
  
  return privateMethods;
};

privateMethods.updateDropdownLinks = function updateDropdownLinks() {
  try {
    const signInLink = document.getElementById('SPSOSignIn')?.querySelector('a');
    const registerLink = document.getElementById('SPSORegister')?.querySelector('a');
    const signInLinkDrawer = document.getElementById('ma-drawer-signin')?.querySelector('a');
    const registerLinkDrawer = document.getElementById('ma-drawer-register')?.querySelector('a');

    const { pathname } = document.location;
    const { hostname } = window.location;
    const referrer = hostname === 'www.homedepot.com' ? null : hostname;
    const queryParams = `?redirect=${pathname}&ref=${referrer}`;

    if (pathname) {
      signInLink?.setAttribute('href', `${signInLink.getAttribute('href')}${queryParams}`);
      registerLink?.setAttribute('href', `${registerLink.getAttribute('href')}${queryParams}`);
      signInLinkDrawer?.setAttribute('href', `${signInLinkDrawer.getAttribute('href')}${queryParams}`);
      registerLinkDrawer?.setAttribute('href', `${registerLinkDrawer.getAttribute('href')}${queryParams}`);
    }

    if (hfConfig.currentChannel === 'mobile') {
      document.getElementById('ma-myaccount-profile')?.setAttribute('href', `//${nonSecureHostName}/auth/view/signin?redirect=/account/view/mobile/menu`);
    }
    document.getElementById('headerMyAccountProfile')?.setAttribute('href', `//${nonSecureHostName}/auth/view/signin?redirect=/account/view/profile`);
    document.getElementById('headerInstantCheckoutSettings')?.setAttribute('href', `//${nonSecureHostName}/auth/view/signin?redirect=/account/view/instantcheckout`);
    document.getElementById('ma-instantCheckout')?.setAttribute('href', `//${nonSecureHostName}/auth/view/signin?redirect=/account/view/instantcheckout`);
    document.getElementById('headerMyAccountSubscription')?.setAttribute('href', `//${nonSecureHostName}/auth/view/signin?redirect=/account/view/ordersubscription`);
    document.getElementById('ma-subscriptions')?.setAttribute('href', `//${nonSecureHostName}/auth/view/signin?redirect=/account/view/ordersubscription`);
    document.getElementById('headerMyAccountMyList')?.setAttribute('href', `//${nonSecureHostName}/auth/view/signin?redirect=/list/view/summary`);
    document.getElementById('ma-lists')?.setAttribute('href', `//${nonSecureHostName}/auth/view/signin?redirect=/list/view/summary`);
    document.getElementById('MobiletaskLinkFav')?.setAttribute('href', `//${nonSecureHostName}/auth/view/signin?redirect=/list/view/summary`);
  } catch (error) {
    console.error(`Updating header myAccount dropdown link error, ${error}`);
  }
};

privateMethods.updateUserStatus = function updateUserStatus() {
  privateMethods.initialize();
  // refresh Cart
  document.dispatchEvent(new Event('cartUpdated'));

  // refresh store
  document.dispatchEvent(new Event('newStoreSet'));
};

privateMethods.logStoreFinderInteraction = function _logStoreFinderInteraction() {
  const text = this.closest('a')?.textContent.toLowerCase();
  return headerAnalytics.logEvent('header click', ['header', 'my account', text].join('>'));
};

privateMethods.logListHeaderClick = function _logListHeaderClick() {
  const text = this.closest('a')?.textContent.toLowerCase().replace(/[^0-9a-zA-Z]/g, '');
  return headerAnalytics.logEvent('header click', ['header', text].join('>'));
};

privateMethods.getSignOutRequest = function getSignOutRequest(url, channelId, Authorization) {
  return fetch(url, {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      channelId,
      Authorization
    }),
    mode: 'cors'
  });
};

privateMethods.signOut = function handleSignOut(event) {
  event.preventDefault();

  /**
     * CustomerAuth service ChannelId
     * 1: Desktop, 2: Mobile
     * @type {number}
     */
  const channelId = hfConfig.currentChannel === 'web' ? 1 : 2;

  const redirectToHomePage = () => window.location.assign(`https://${nonSecureHostName}`);
  const reloadPage = (xhr) => {
    if (xhr && xhr.status === 401) {
      privateMethods.reloadPage();
    }
  };

  let url;
  let fetch;
  url = `https://${nonSecureHostName}/customer/auth/v1/logout`;
  const authorization = thdCustomer.token || cookieUtils.readBrowserCookie('THD_USER_SESSION');

  fetch = privateMethods.getSignOutRequest(url, channelId, authorization)
    .then((response) => {
      if (!response.ok) {
        throw new Error(response.error)
      }
      return response.json();
    })
    .then(redirectToHomePage)
    .catch(reloadPage);
  return fetch;
};

/*
   * Public Methods
   */
maml.init = function init(useJsonP) {
  const events = ['click', 'touchend'];
  utils.delegateListeners(events, '#headerMyAccountDropdown .MyAccount__link', privateMethods.logStoreFinderInteraction);
  utils.delegateListeners(events, '#headerMyAccountList', privateMethods.logListHeaderClick);
  document.addEventListener('updateUserStatus', privateMethods.updateUserStatus);
  utils.delegateListeners(['click'], '#myaccount-switch-accounts', privateMethods.logListHeaderClick);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => privateMethods.initialize(useJsonP));
  } else {
    privateMethods.initialize(useJsonP);
  }
  
  return this;
};

maml.getPrivateMethods = function getPrivateMethods() {
  return privateMethods;
};

export default maml;